import "../Quizes.scss"
import { useEffect, useRef, useState } from "react";
import { get_question_answers } from "../../../../server/requests";

const Questions = ({
    configs, changeComponent,
    questionData, questionNumber, setQuestionNumber,
    getElmId, setElmId, allIndex, setAllIndex,
    isAnswerChecked, setIsAnswerCheked
}) => {

    const icon = configs?.logo

    return (
        <div className="questions-main">

            <div className="questions-fragment">

                <div className="icon">
                    <img src={icon} alt="" />
                </div>

                <div className="progress">

                    <div className="level">
                        <svg width="3.4rem" height="3rem" viewBox="0 0 34 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.1541 12.4589C7.57165 12.4589 7.91025 12.1204 7.91025 11.7028C7.91025 11.0773 8.41906 10.5685 9.04447 10.5685C9.66989 10.5685 10.1787 11.0773 10.1787 11.7028C10.1787 12.0057 10.0579 12.2933 9.83843 12.5127C8.96016 13.3909 8.28832 14.1421 8.28832 15.1407C8.28832 15.5584 8.62693 15.8969 9.04447 15.8969C9.46202 15.8969 9.80062 15.5584 9.80062 15.1407C9.80062 14.8031 10.0799 14.4098 10.9078 13.582C11.4129 13.077 11.691 12.4096 11.691 11.7027C11.691 10.2434 10.5038 9.05615 9.04447 9.05615C7.58518 9.05615 6.39795 10.2434 6.39795 11.7027C6.39795 12.1204 6.73655 12.4589 7.1541 12.4589Z" fill="white" />
                            <path d="M9.04521 16.6523C8.62767 16.6523 8.28906 16.9909 8.28906 17.4085V17.409C8.28906 17.8266 8.62767 18.1649 9.04521 18.1649C9.46276 18.1649 9.80136 17.8261 9.80136 17.4085C9.80136 16.9909 9.46283 16.6523 9.04521 16.6523Z" fill="white" />
                            <path d="M14.2747 10.5685H24.3013C24.7189 10.5685 25.0575 10.2299 25.0575 9.8123C25.0575 9.39468 24.7189 9.05615 24.3013 9.05615H14.2747C13.8572 9.05615 13.5186 9.39468 13.5186 9.8123C13.5186 10.2299 13.8572 10.5685 14.2747 10.5685Z" fill="#FF8026" />
                            <path d="M14.2747 14.3668H24.3013C24.7189 14.3668 25.0575 14.0283 25.0575 13.6106C25.0575 13.193 24.7189 12.8545 24.3013 12.8545H14.2747C13.8572 12.8545 13.5186 13.193 13.5186 13.6106C13.5186 14.0283 13.8572 14.3668 14.2747 14.3668Z" fill="#FF8026" />
                            <path d="M14.2747 18.1656H24.3013C24.7189 18.1656 25.0575 17.8271 25.0575 17.4095C25.0575 16.9918 24.7189 16.6533 24.3013 16.6533H14.2747C13.8572 16.6533 13.5186 16.9918 13.5186 17.4095C13.5186 17.8271 13.8572 18.1656 14.2747 18.1656Z" fill="#FF8026" />
                            <path d="M15.4422 0H18.1311C26.6459 0 33.5732 6.10896 33.5732 13.6179C33.5732 21.1268 26.6459 27.2357 18.1312 27.2357H15.4423C14.1133 27.2357 12.7979 27.0868 11.523 26.7926L7.55082 30.2935C7.34758 30.4726 7.07602 30.5677 6.79957 30.5677C6.66262 30.5677 6.52451 30.5444 6.39308 30.4964C5.99615 30.3513 5.73734 30.0097 5.73734 29.6308V24.2101C4.05561 23.0091 2.65861 21.4919 1.67819 19.797C0.564648 17.872 0.000175476 15.793 0.000175476 13.6179C0.000175476 6.10896 6.92749 0 15.4422 0ZM7.43905 23.0049C7.70541 23.1818 7.86222 23.459 7.86222 23.7533V27.3698L10.4621 25.0783C10.6644 24.9001 10.9358 24.804 11.2133 24.804C11.3174 24.804 11.4226 24.8176 11.5252 24.8455C12.7898 25.1882 14.1077 25.3619 15.4422 25.3619H18.1311C25.4744 25.3619 31.4484 20.0935 31.4484 13.6179C31.4484 7.1422 25.4743 1.87386 18.1311 1.87386H15.4422C8.09904 1.87386 2.12505 7.1422 2.12505 13.6179C2.12505 17.3404 4.06188 20.7619 7.43905 23.0049Z" fill="#FF8026" />
                        </svg>
                        <p>Question {questionNumber + 1} :</p>
                    </div>

                    <div className="count">
                        <p>{questionNumber + 1}/{questionData.length}</p>
                    </div>

                </div>

                <AnswerCard
                    changeComponent={changeComponent}
                    questionData={questionData}
                    questionNumber={questionNumber}
                    setQuestionNumber={setQuestionNumber}
                    getElmId={getElmId}
                    setElmId={setElmId}
                    allIndex={allIndex}
                    setAllIndex={setAllIndex}
                    isAnswerChecked={isAnswerChecked}
                    setIsAnswerCheked={setIsAnswerCheked}
                />

            </div>

        </div>
    )

}

export default Questions;

export const AnswerCard = ({
    changeComponent,
    questionData,
    questionNumber,
    setQuestionNumber,
    getElmId,
    setElmId,
    allIndex,
    setAllIndex,
    isAnswerChecked,
    setIsAnswerCheked
}) => {


    let questionAnswers = questionData[questionNumber]

    let allAnswersIndex = allIndex ? allIndex : []

    const getAnswer = (e) => {

        setElmId(e)

        if (!isAnswerChecked) {

            let submit_button_disable = document.querySelector('.sbmit_btn')

            submit_button_disable.classList.add('opacity')

        }


    }

    const submitAnswer = () => {

        let submit_button_style = document.querySelector('.opacity')

        submit_button_style.classList.remove('opacity')


        if (isAnswerChecked) {

            allAnswersIndex.push(getElmId)

            setQuestionNumber(questionNumber + 1)

        }

        setIsAnswerCheked(false)

    }

    const skipQuestion = () => {

        setQuestionNumber(questionNumber + 1)

    }

    const viewResult = () => {

        setIsAnswerCheked(false)

        if (isAnswerChecked) {

            allAnswersIndex.push(getElmId)
            setAllIndex(allAnswersIndex)

            let body = {
                answers: JSON.stringify(allIndex)
            }

            get_question_answers(body, res => {

                changeComponent('end', res.level)

            },
                err => console.log(err)

            )

        }

    }
    const skipViewResult = () => {

        let body = { answers: JSON.stringify(allIndex) }

        get_question_answers(body, res => changeComponent('end', res.level), err => console.log(err))

    }

    const isChecked = (e) => setIsAnswerCheked(true)

    return (
        <>

            <div className="question">

                <div className="question-context">
                    <h1 className="question-text">{questionAnswers.content}</h1>
                </div>

                <div className="answers">

                    {questionAnswers.answers.map((el, i) => {

                        return (

                            <div key={el.id}>
                                <label className='answer-btn' onClick={() => getAnswer(el.id)}>
                                    <div className="inp-width">
                                        <input className="form-control" name="question" type='radio' onClick={(e) => isChecked(e)} />
                                    </div>
                                    {el.content}
                                </label>
                            </div>

                        )

                    })}

                </div>

                <SubmitCard
                    submitAnswer={submitAnswer}
                    questionNumber={questionNumber}
                    skipQuestion={skipQuestion}
                    viewResult={viewResult}
                    questionData={questionData}
                    skipViewResult={skipViewResult}
                />

            </div>
        </>
    )
}
export const SubmitCard = ({ submitAnswer, questionNumber, skipQuestion, viewResult, questionData, skipViewResult }) => {

    const [submitAnswers, setSubmitAnswers] = useState(false)

    useEffect(() => {

        if (questionNumber + 1 == questionData.length) setSubmitAnswers(true)

        else setSubmitAnswers(false)

    })

    return (
        <>
            {submitAnswers ?
                <div className="functional">
                    <button className='sbmit_btn' onClick={viewResult}>Submit Answer</button>
                    <button onClick={skipViewResult}>Skip Question</button>
                </div>
                :
                <div className="functional">
                    <button className='sbmit_btn' onClick={submitAnswer}>Submit Answer</button>
                    <button onClick={skipQuestion}>Skip Question</button>
                </div>
            }
        </>
    )
}
